'use client'

import { useMemo } from 'react'
import { Language, getBrief613Translation, Brief613Translations } from '@/lib/brief613/translations'

export function useBrief613Translation(language: Language): Brief613Translations {
  return useMemo(() => getBrief613Translation(language), [language])
}

